import React from "react";

const Awards = () => {
  return (
    <div className="each-container" id="awards-container">
      <div className="awards-part">
        <div id="awards">
          <div className="title">Services & Teaching</div>
         
          <b>Reviewer</b>
          <ul>
            <li>
            CHI (recieved "Special Recognitions", 2026)
            </li>
            <li>
            UIST (recieved "Special Recognitions", 2026)
            </li>
          </ul>
          <b>Teaching Assistant</b>
          <ul>
            <li>
            CMAA 5018: Assistive Technology Design (Fall 2024)
            </li>
            <li>
            UCMP 6030: Cross-disciplinary Design Thinking I (Spring 2025)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Awards;
